import {get} from 'lodash';
import * as actionType from './UserSettingsActionsType';
import UserSettingsService from './service/UserSettingsService';

const getNotifications = async () => {
  const notifications = await UserSettingsService.getNotifications();
  return get(notifications, '[0]._id', '');
}

const handleNotification = async (email, shouldDisableAlerts = false) => {
  if (shouldDisableAlerts) {
    const id = await UserSettingsService.disableNotification();
    return id;
  }

  await UserSettingsService.registerNotification(email);
  const notificationId = await getNotifications();

  if (!notificationId) {
    throw new Error('Error trying to get notification id');
  }

  return notificationId;
};

export const getSettings = params => async dispatch => {
  dispatch({type: actionType.GET_USERSETTINGS_REQUEST});
  try {
    const settings = await UserSettingsService.getSettings(params);
    settings.notificationId = await getNotifications();
    dispatch({type: actionType.GET_USERSETTINGS_SUCCESS, payload: settings});
  } catch (e) {
    console.error('Unable to get user settings', e);
    dispatch({type: actionType.GET_USERSETTINGS_FAIL});
  }
};

export const updateSettings = (userId, settings) => async dispatcher => {
  dispatcher({type: actionType.UPDATE_USERSETTINGS_REQUEST});
  try {
    const response = await UserSettingsService.updateSettings(userId, settings);
    dispatcher({type: actionType.UPDATE_USERSETTINGS_SUCCESS, payload: response});
  } catch (e) {
    console.error('Something went wrong when saving the settings', e);
    dispatcher({type: actionType.UPDATE_USERSETTINGS_FAIL});
  }
};

export const updateEmailAlert = ({userId, email}, settings) => async dispatcher => {
  dispatcher({type: actionType.UPDATE_EMAILALERT_REQUEST});
  try {
    const shouldDisableAlerts = settings.eventVideoAlerts.length === 0;
    const notificationId = await handleNotification(email, shouldDisableAlerts);
    const response = await UserSettingsService.updateSettings(userId, settings);
    response.notificationId = notificationId;
    dispatcher({type: actionType.UPDATE_EMAILALERT_SUCCESS, payload: response});
  } catch (e) {
    console.error('Something went wrong when saving the event video alerts settings', e);
    dispatcher({type: actionType.UPDATE_EMAILALERT_FAIL});
  }
};

